// Loader.js
import React from 'react';

const Loader = () => {
  return (
    <div
      className="w-4 h-4 border-4 border-t-4 border-blue-500 border-solid rounded-full animate-spin"
      style={{ borderTopColor: '#ffffff', borderRightColor: '#ffffff', borderBottomColor: '#ffffff', borderLeftColor: '#3498db' }}
    ></div>
  );
};

export default Loader;
